export function getProductRecap(page, amount, search, isEmployee) {
    let { getProductRecapRequest, getProductRecapError, getProductRecapResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/product/get_product_list',
        this.createBundle(
            'app/product/get_product_list',
            { page, amount, search },
            this.POST,
            getProductRecapRequest,
            getProductRecapResult,
            getProductRecapError,
            isEmployee
        )
    )
}
